import { formatNumberWithSep, Region } from '@fx-ui/platform-sdk';
import { DayjsType, isNil, pick, transformNormalFormat } from '@libs/shared';

const formatDatetime = (props: {
    value?: DayjsType | null;
    region: Region;
    formatType: keyof Region['dateTimeFormat'];
}) => {
    const { value, region, formatType } = props;
    return isNil(value) ? '' : value.format(region.dateTimeFormat[formatType]);
};

const formatNumber = (props: { value?: number | string; region: Region }) => {
    const { value, region } = props;
    return isNil(value)
        ? ''
        : String(value)
              .split('')
              .map((char) => {
                  if (char === ',') {
                      return region.thousandSeparator;
                  } else if (char === '.') {
                      return region.decimalSeparator;
                  }
                  return char;
              })
              .join('');
};

const formatThousandNumber = (props: { value: any; region: Region }) => {
    const { value, region } = props;
    return formatNumberWithSep(value, {
        thousand: region.thousandSeparator,
        decimal: region.decimalSeparator
    });
};

const getDatetimeFormat = (props: {
    region: Region;
    formatType: keyof Region['dateTimeFormat'];
}) => {
    const { region, formatType } = props;
    return { format: transformNormalFormat(region.dateTimeFormat[formatType]) };
};

const getInputNumberSep = (props: { region: Region }) => {
    const { region } = props;
    return pick(region, 'decimalSeparator');
};

export const regionUtils = {
    formatDatetime,
    formatNumber,
    formatThousandNumber,
    getDatetimeFormat,
    getInputNumberSep
};
